import type { ReactNode } from "react";
import PhaseSixIcon, { type TIconNames } from "../phaseSixIcon/PhaseSixIcon";
import DesignConstants from "../../constants/DesignConstants";
import useBreakpoints, { Breakpoint } from "../../hooks/useBreakpoints";

const ICON_BUTTON_SIZE = "h-[45px] w-[45px]";

export interface ResponsiveButtonProps {
    onClick: () => void;
    iconName: TIconNames;
    // used as aria-label on the mobile icon button
    label: string;
    children: ReactNode;
}

const ResponsiveButton = (props: ResponsiveButtonProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const desktopVisibility = getStyleBasedOnBreakpoint(Breakpoint.MD, "block", "hidden");
    const mobileVisibility = getStyleBasedOnBreakpoint(Breakpoint.MD, "hidden", "block");

    return (
        <>
            <div className={desktopVisibility}>{props.children}</div>
            <div className={mobileVisibility}>
                <button
                    type="button"
                    onClick={props.onClick}
                    aria-label={props.label}
                    className={`flex ${ICON_BUTTON_SIZE} cursor-pointer items-center justify-center rounded-circle border border-solid border-p6-grey-mid bg-white hover:bg-p6-grey-lightest`}
                >
                    <PhaseSixIcon
                        name={props.iconName}
                        color={DesignConstants.COLORS.DARK_GREY}
                    />
                </button>
            </div>
        </>
    );
};

export default ResponsiveButton;
